import type { FC } from 'react'
import { Fragment, lazy, Suspense } from 'react'

import type { SystemErrorProps } from './SystemError.types'

const SystemError = lazy(() => import('./SystemError'))

/**
 * Lazy Loaded version of SystemError, it uses react transition library and increases bundle size.
 */
export const SystemErrorLazy: FC<SystemErrorProps> = ({
  errors,
  onDismiss,
}) => (
  <Suspense fallback={<Fragment />}>
    <SystemError errors={errors} onDismiss={onDismiss} />
  </Suspense>
)
